{
  "description": "Generated by scripts/i18n-native-dates.mjs from CLDR (Node ICU). Used by utils/format.js when the browser has no date data for the language. Do not edit by hand.",
  "icu": "76.1",
  "languages": {
    "az": {
      "tag": "az-Latn-AZ",
      "months": {
        "format": {
          "long": [
            "yanvar",
            "fevral",
            "mart",
            "aprel",
            "may",
            "iyun",
            "iyul",
            "avqust",
            "sentyabr",
            "oktyabr",
            "noyabr",
            "dekabr"
          ],
          "short": [
            "yan",
            "fev",
            "mar",
            "apr",
            "may",
            "iyn",
            "iyl",
            "avq",
            "sen",
            "okt",
            "noy",
            "dek"
          ]
        },
        "standalone": {
          "long": [
            "yanvar",
            "fevral",
            "mart",
            "aprel",
            "may",
            "iyun",
            "iyul",
            "avqust",
            "sentyabr",
            "oktyabr",
            "noyabr",
            "dekabr"
          ],
          "short": [
            "yan",
            "fev",
            "mar",
            "apr",
            "may",
            "iyn",
            "iyl",
            "avq",
            "sen",
            "okt",
            "noy",
            "dek"
          ]
        }
      },
      "weekdays": {
        "format": {
          "long": [
            "bazar",
            "bazar ertəsi",
            "çərşənbə axşamı",
            "çərşənbə",
            "cümə axşamı",
            "cümə",
            "şənbə"
          ],
          "short": [
            "B.",
            "B.e.",
            "Ç.a.",
            "Ç.",
            "C.a.",
            "C.",
            "Ş."
          ]
        },
        "standalone": {
          "long": [
            "bazar",
            "bazar ertəsi",
            "çərşənbə axşamı",
            "çərşənbə",
            "cümə axşamı",
            "cümə",
            "şənbə"
          ],
          "short": [
            "B.",
            "B.E.",
            "Ç.A.",
            "Ç.",
            "C.A.",
            "C.",
            "Ş."
          ]
        }
      },
      "patterns": {
        "||short|": "{month}",
        "||short|d": "{day} {month}",
        "||long|": "{month}",
        "||long|d": "{day} {month}",
        "|y|short|": "{month} {year}",
        "|y|short|d": "{day} {month} {year}",
        "|y|long|": "{month} {year}",
        "|y|long|d": "{day} {month} {year}",
        "short|||": "{Weekday}",
        "short|||d": "{day} {weekday}",
        "short||numeric|": "{monthNum} {Weekday}",
        "short||numeric|d": "{day}.{monthNum}, {weekday}",
        "short||short|": "{month} {Weekday}",
        "short||short|d": "{day} {month}, {weekday}",
        "short||long|": "{Weekday} (Ay: {month})",
        "short||long|d": "{day} {month}, {weekday}",
        "short|y||": "{year} {Weekday}",
        "short|y||d": "{year} {day} {weekday}",
        "short|y|numeric|": "{monthNum}.{year} {Weekday}",
        "short|y|numeric|d": "{day}.{monthNum}.{year}, {weekday}",
        "short|y|short|": "{month} {year} {Weekday}",
        "short|y|short|d": "{day} {month} {year}, {weekday}",
        "short|y|long|": "{month} {year} {Weekday}",
        "short|y|long|d": "{day} {month} {year}, {weekday}",
        "long|||": "{weekday}",
        "long|||d": "{day} {weekday}",
        "long||numeric|": "{monthNum} {weekday}",
        "long||numeric|d": "{day}.{monthNum}, {weekday}",
        "long||short|": "{month} {weekday}",
        "long||short|d": "{day} {month}, {weekday}",
        "long||long|": "{month} {weekday}",
        "long||long|d": "{day} {month}, {weekday}",
        "long|y||": "{year} {weekday}",
        "long|y||d": "{year} {day} {weekday}",
        "long|y|numeric|": "{monthNum}.{year} {weekday}",
        "long|y|numeric|d": "{day}.{monthNum}.{year}, {weekday}",
        "long|y|short|": "{month} {year} {weekday}",
        "long|y|short|d": "{day} {month} {year}, {weekday}",
        "long|y|long|": "{month} {year} {weekday}",
        "long|y|long|d": "{day} {month} {year}, {weekday}"
      },
      "dateTimeGlue": ", ",
      "relative": {
        "second": {
          "past": "{0} saniyə öncə",
          "future": "{0} saniyə ərzində",
          "auto": {
            "0": "indi"
          }
        },
        "minute": {
          "past": "{0} dəqiqə öncə",
          "future": "{0} dəqiqə ərzində",
          "auto": {
            "0": "bu dəqiqə"
          }
        },
        "hour": {
          "past": "{0} saat öncə",
          "future": "{0} saat ərzində",
          "auto": {
            "0": "bu saat"
          }
        },
        "day": {
          "past": "{0} gün öncə",
          "future": "{0} gün ərzində",
          "auto": {
            "0": "bu gün",
            "1": "sabah",
            "-1": "dünən"
          }
        },
        "week": {
          "past": "{0} həftə öncə",
          "future": "{0} həftə ərzində",
          "auto": {
            "0": "bu həftə",
            "1": "gələn həftə",
            "-1": "keçən həftə"
          }
        },
        "month": {
          "past": "{0} ay öncə",
          "future": "{0} ay ərzində",
          "auto": {
            "0": "bu ay",
            "1": "gələn ay",
            "-1": "keçən ay"
          }
        },
        "year": {
          "past": "{0} il öncə",
          "future": "{0} il ərzində",
          "auto": {
            "0": "bu il",
            "1": "gələn il",
            "-1": "keçən il"
          }
        }
      }
    },
    "uz": {
      "tag": "uz-Latn-UZ",
      "months": {
        "format": {
          "long": [
            "yanvar",
            "fevral",
            "mart",
            "aprel",
            "may",
            "iyun",
            "iyul",
            "avgust",
            "sentabr",
            "oktabr",
            "noyabr",
            "dekabr"
          ],
          "short": [
            "yan",
            "fev",
            "mar",
            "apr",
            "may",
            "iyn",
            "iyl",
            "avg",
            "sen",
            "okt",
            "noy",
            "dek"
          ]
        },
        "standalone": {
          "long": [
            "Yanvar",
            "Fevral",
            "Mart",
            "Aprel",
            "May",
            "Iyun",
            "Iyul",
            "Avgust",
            "Sentabr",
            "Oktabr",
            "Noyabr",
            "Dekabr"
          ],
          "short": [
            "Yan",
            "Fev",
            "Mar",
            "Apr",
            "May",
            "Iyn",
            "Iyl",
            "Avg",
            "Sen",
            "Okt",
            "Noy",
            "Dek"
          ]
        }
      },
      "weekdays": {
        "format": {
          "long": [
            "yakshanba",
            "dushanba",
            "seshanba",
            "chorshanba",
            "payshanba",
            "juma",
            "shanba"
          ],
          "short": [
            "Yak",
            "Dush",
            "Sesh",
            "Chor",
            "Pay",
            "Jum",
            "Shan"
          ]
        },
        "standalone": {
          "long": [
            "yakshanba",
            "dushanba",
            "seshanba",
            "chorshanba",
            "payshanba",
            "juma",
            "shanba"
          ],
          "short": [
            "Yak",
            "Dush",
            "Sesh",
            "Chor",
            "Pay",
            "Jum",
            "Shan"
          ]
        }
      },
      "patterns": {
        "||short|": "{Month}",
        "||short|d": "{day}-{month}",
        "||long|": "{Month}",
        "||long|d": "{day}-{month}",
        "|y|short|": "{month}, {year}",
        "|y|short|d": "{day}-{month}, {year}",
        "|y|long|": "{month}, {year}",
        "|y|long|d": "{day}-{month}, {year}",
        "short|||": "{weekday}",
        "short|||d": "{day}, {weekday}",
        "short||numeric|": "{monthNum} {weekday}",
        "short||numeric|d": "{weekday}, {day}/{monthNum}",
        "short||short|": "{Month} {weekday}",
        "short||short|d": "{weekday}, {day}-{month}",
        "short||long|": "{weekday} (oy: {Month})",
        "short||long|d": "{weekday}, {day}-{month}",
        "short|y||": "{year} {weekday}",
        "short|y||d": "{year} {day}, {weekday}",
        "short|y|numeric|": "{monthNum}.{year} {weekday}",
        "short|y|numeric|d": "{weekday}, {day}/{monthNum}/{year}",
        "short|y|short|": "{month}, {year} {weekday}",
        "short|y|short|d": "{weekday}, {day}-{month}, {year}",
        "short|y|long|": "{month}, {year} {weekday}",
        "short|y|long|d": "{weekday}, {day}-{month}, {year}",
        "long|||": "{weekday}",
        "long|||d": "{day}, {weekday}",
        "long||numeric|": "{monthNum} {weekday}",
        "long||numeric|d": "{weekday}, {day}/{monthNum}",
        "long||short|": "{Month} {weekday}",
        "long||short|d": "{weekday}, {day}-{month}",
        "long||long|": "{Month} {weekday}",
        "long||long|d": "{weekday}, {day}-{month}",
        "long|y||": "{year} {weekday}",
        "long|y||d": "{year} {day}, {weekday}",
        "long|y|numeric|": "{monthNum}.{year} {weekday}",
        "long|y|numeric|d": "{weekday}, {day}/{monthNum}/{year}",
        "long|y|short|": "{month}, {year} {weekday}",
        "long|y|short|d": "{weekday}, {day}-{month}, {year}",
        "long|y|long|": "{month}, {year} {weekday}",
        "long|y|long|d": "{weekday}, {day}-{month}, {year}"
      },
      "dateTimeGlue": ", ",
      "relative": {
        "second": {
          "past": "{0} soniya oldin",
          "future": "{0} soniyadan keyin",
          "auto": {
            "0": "hozir"
          }
        },
        "minute": {
          "past": "{0} daqiqa oldin",
          "future": "{0} daqiqadan keyin",
          "auto": {
            "0": "shu daqiqada"
          }
        },
        "hour": {
          "past": "{0} soat oldin",
          "future": "{0} soatdan keyin",
          "auto": {
            "0": "shu soatda"
          }
        },
        "day": {
          "past": "{0} kun oldin",
          "future": "{0} kundan keyin",
          "auto": {
            "0": "bugun",
            "1": "ertaga",
            "-1": "kecha"
          }
        },
        "week": {
          "past": "{0} hafta oldin",
          "future": "{0} haftadan keyin",
          "auto": {
            "0": "shu hafta",
            "1": "keyingi hafta",
            "-1": "oʻtgan hafta"
          }
        },
        "month": {
          "past": "{0} oy oldin",
          "future": "{0} oydan keyin",
          "auto": {
            "0": "shu oy",
            "1": "keyingi oy",
            "-1": "oʻtgan oy"
          }
        },
        "year": {
          "past": "{0} yil oldin",
          "future": "{0} yildan keyin",
          "auto": {
            "0": "shu yil",
            "1": "keyingi yil",
            "-1": "oʻtgan yil"
          }
        }
      }
    },
    "kk": {
      "tag": "kk-KZ",
      "months": {
        "format": {
          "long": [
            "қаңтар",
            "ақпан",
            "наурыз",
            "сәуір",
            "мамыр",
            "маусым",
            "шілде",
            "тамыз",
            "қыркүйек",
            "қазан",
            "қараша",
            "желтоқсан"
          ],
          "short": [
            "қаң.",
            "ақп.",
            "нау.",
            "сәу.",
            "мам.",
            "мау.",
            "шіл.",
            "там.",
            "қыр.",
            "қаз.",
            "қар.",
            "жел."
          ]
        },
        "standalone": {
          "long": [
            "Қаңтар",
            "Ақпан",
            "Наурыз",
            "Сәуір",
            "Мамыр",
            "Маусым",
            "Шілде",
            "Тамыз",
            "Қыркүйек",
            "Қазан",
            "Қараша",
            "Желтоқсан"
          ],
          "short": [
            "қаң.",
            "ақп.",
            "нау.",
            "сәу.",
            "мам.",
            "мау.",
            "шіл.",
            "там.",
            "қыр.",
            "қаз.",
            "қар.",
            "жел."
          ]
        }
      },
      "weekdays": {
        "format": {
          "long": [
            "жексенбі",
            "дүйсенбі",
            "сейсенбі",
            "сәрсенбі",
            "бейсенбі",
            "жұма",
            "сенбі"
          ],
          "short": [
            "жс",
            "дс",
            "сс",
            "ср",
            "бс",
            "жм",
            "сб"
          ]
        },
        "standalone": {
          "long": [
            "жексенбі",
            "дүйсенбі",
            "сейсенбі",
            "сәрсенбі",
            "бейсенбі",
            "жұма",
            "сенбі"
          ],
          "short": [
            "жс",
            "дс",
            "сс",
            "ср",
            "бс",
            "жм",
            "сб"
          ]
        }
      },
      "patterns": {
        "||short|": "{month}",
        "||short|d": "{day} {month}",
        "||long|": "{Month}",
        "||long|d": "{day} {month}",
        "|y|short|": "{year} ж. {month}",
        "|y|short|d": "{year} ж. {day} {month}",
        "|y|long|": "{year} ж. {month}",
        "|y|long|d": "{year} ж. {day} {month}",
        "short|||": "{weekday}",
        "short|||d": "{day}, {weekday}",
        "short||numeric|": "{monthNum} {weekday}",
        "short||numeric|d": "{day}.{monthNum}, {weekday}",
        "short||short|": "{month} {weekday}",
        "short||short|d": "{day} {month}, {weekday}",
        "short||long|": "{weekday} (ай: {Month})",
        "short||long|d": "{day} {month}, {weekday}",
        "short|y||": "{year} {weekday}",
        "short|y||d": "{year} {day}, {weekday}",
        "short|y|numeric|": "{monthNum}.{year} {weekday}",
        "short|y|numeric|d": "{day}.{monthNum}.{year}, {weekday}",
        "short|y|short|": "{year} ж. {month} {weekday}",
        "short|y|short|d": "{year} ж. {day} {month}, {weekday}",
        "short|y|long|": "{year} ж. {month} {weekday}",
        "short|y|long|d": "{year} ж. {day} {month}, {weekday}",
        "long|||": "{weekday}",
        "long|||d": "{day}, {weekday}",
        "long||numeric|": "{monthNum} {weekday}",
        "long||numeric|d": "{day}.{monthNum}, {weekday}",
        "long||short|": "{month} {weekday}",
        "long||short|d": "{day} {month}, {weekday}",
        "long||long|": "{Month} {weekday}",
        "long||long|d": "{day} {month}, {weekday}",
        "long|y||": "{year} {weekday}",
        "long|y||d": "{year} {day}, {weekday}",
        "long|y|numeric|": "{monthNum}.{year} {weekday}",
        "long|y|numeric|d": "{day}.{monthNum}.{year}, {weekday}",
        "long|y|short|": "{year} ж. {month} {weekday}",
        "long|y|short|d": "{year} ж. {day} {month}, {weekday}",
        "long|y|long|": "{year} ж. {month} {weekday}",
        "long|y|long|d": "{year} ж. {day} {month}, {weekday}"
      },
      "dateTimeGlue": ", ",
      "relative": {
        "second": {
          "past": "{0} секунд бұрын",
          "future": "{0} секундтан кейін",
          "auto": {
            "0": "қазір"
          }
        },
        "minute": {
          "past": "{0} минут бұрын",
          "future": "{0} минуттан кейін",
          "auto": {
            "0": "осы минут"
          }
        },
        "hour": {
          "past": "{0} сағат бұрын",
          "future": "{0} сағаттан кейін",
          "auto": {
            "0": "осы сағат"
          }
        },
        "day": {
          "past": "{0} күн бұрын",
          "future": "{0} күннен кейін",
          "auto": {
            "0": "бүгін",
            "1": "ертең",
            "2": "бүрсігүні",
            "-2": "алдыңгүні",
            "-1": "кеше"
          }
        },
        "week": {
          "past": "{0} апта бұрын",
          "future": "{0} аптадан кейін",
          "auto": {
            "0": "осы апта",
            "1": "келесі апта",
            "-1": "өткен апта"
          }
        },
        "month": {
          "past": "{0} ай бұрын",
          "future": "{0} айдан кейін",
          "auto": {
            "0": "осы ай",
            "1": "келесі ай",
            "-1": "өткен ай"
          }
        },
        "year": {
          "past": "{0} жыл бұрын",
          "future": "{0} жылдан кейін",
          "auto": {
            "0": "биылғы жыл",
            "1": "келесі жыл",
            "-1": "былтырғы жыл"
          }
        }
      }
    },
    "ky": {
      "tag": "ky-KG",
      "months": {
        "format": {
          "long": [
            "январь",
            "февраль",
            "март",
            "апрель",
            "май",
            "июнь",
            "июль",
            "август",
            "сентябрь",
            "октябрь",
            "ноябрь",
            "декабрь"
          ],
          "short": [
            "янв.",
            "фев.",
            "мар.",
            "апр.",
            "май",
            "июн.",
            "июл.",
            "авг.",
            "сен.",
            "окт.",
            "ноя.",
            "дек."
          ]
        },
        "standalone": {
          "long": [
            "Январь",
            "Февраль",
            "Март",
            "Апрель",
            "Май",
            "Июнь",
            "Июль",
            "Август",
            "Сентябрь",
            "Октябрь",
            "Ноябрь",
            "Декабрь"
          ],
          "short": [
            "Янв",
            "Фев",
            "Мар",
            "Апр",
            "Май",
            "Июн",
            "Июл",
            "Авг",
            "Сен",
            "Окт",
            "Ноя",
            "Дек"
          ]
        }
      },
      "weekdays": {
        "format": {
          "long": [
            "жекшемби",
            "дүйшөмбү",
            "шейшемби",
            "шаршемби",
            "бейшемби",
            "жума",
            "ишемби"
          ],
          "short": [
            "жек.",
            "дүй.",
            "шейш.",
            "шарш.",
            "бейш.",
            "жума",
            "ишм."
          ]
        },
        "standalone": {
          "long": [
            "жекшемби",
            "дүйшөмбү",
            "шейшемби",
            "шаршемби",
            "бейшемби",
            "жума",
            "ишемби"
          ],
          "short": [
            "жек.",
            "дүй.",
            "шейш.",
            "шарш.",
            "бейш.",
            "жума",
            "ишм."
          ]
        }
      },
      "patterns": {
        "||short|": "{Month}",
        "||short|d": "{day}-{month}",
        "||long|": "{Month}",
        "||long|d": "{day}-{month}",
        "|y|short|": "{year}-ж. {month}",
        "|y|short|d": "{year}-ж. {day}-{month}",
        "|y|long|": "{year}-ж., {month}",
        "|y|long|d": "{year}-ж., {day}-{month}",
        "short|||": "{weekday}",
        "short|||d": "{day}, {weekday}",
        "short||numeric|": "{monthNum} {weekday}",
        "short||numeric|d": "{day}-{monthNum}, {weekday}",
        "short||short|": "{Month} {weekday}",
        "short||short|d": "{day}-{month}, {weekday}",
        "short||long|": "{weekday} (ай: {Month})",
        "short||long|d": "{day}-{month}, {weekday}",
        "short|y||": "{year} {weekday}",
        "short|y||d": "{year} {day}, {weekday}",
        "short|y|numeric|": "{year}-{monthNum} {weekday}",
        "short|y|numeric|d": "{year}-{day}-{monthNum}, {weekday}",
        "short|y|short|": "{year}-ж. {month} {weekday}",
        "short|y|short|d": "{year}-ж. {day}-{month}, {weekday}",
        "short|y|long|": "{year}-ж., {month} {weekday}",
        "short|y|long|d": "{year}-ж., {day}-{month}, {weekday}",
        "long|||": "{weekday}",
        "long|||d": "{day}, {weekday}",
        "long||numeric|": "{monthNum} {weekday}",
        "long||numeric|d": "{day}-{monthNum}, {weekday}",
        "long||short|": "{Month} {weekday}",
        "long||short|d": "{day}-{month}, {weekday}",
        "long||long|": "{Month} {weekday}",
        "long||long|d": "{day}-{month}, {weekday}",
        "long|y||": "{year} {weekday}",
        "long|y||d": "{year} {day}, {weekday}",
        "long|y|numeric|": "{year}-{monthNum} {weekday}",
        "long|y|numeric|d": "{year}-{day}-{monthNum}, {weekday}",
        "long|y|short|": "{year}-ж. {month} {weekday}",
        "long|y|short|d": "{year}-ж., {day}-{month}, {weekday}",
        "long|y|long|": "{year}-ж., {month} {weekday}",
        "long|y|long|d": "{year}-ж., {day}-{month}, {weekday}"
      },
      "dateTimeGlue": " ",
      "relative": {
        "second": {
          "past": "{0} секунд мурун",
          "future": "{0} секунддан кийин",
          "auto": {
            "0": "азыр"
          }
        },
        "minute": {
          "past": "{0} мүнөт мурун",
          "future": "{0} мүнөттөн кийин",
          "auto": {
            "0": "ушул мүнөттө"
          }
        },
        "hour": {
          "past": "{0} саат мурун",
          "future": "{0} сааттан кийин",
          "auto": {
            "0": "ушул саатта"
          }
        },
        "day": {
          "past": "{0} күн мурун",
          "future": "{0} күндөн кийин",
          "auto": {
            "0": "бүгүн",
            "1": "эртең",
            "2": "бүрсүгүнү",
            "-2": "мурдагы күнү",
            "-1": "кечээ"
          }
        },
        "week": {
          "past": "{0} апта мурун",
          "future": "{0} аптадан кийин",
          "auto": {
            "0": "ушул аптада",
            "1": "келерки аптада",
            "-1": "өткөн аптада"
          }
        },
        "month": {
          "past": "{0} ай мурун",
          "future": "{0} айдан кийин",
          "auto": {
            "0": "бул айда",
            "1": "эмдиги айда",
            "-1": "өткөн айда"
          }
        },
        "year": {
          "past": "{0} жыл мурун",
          "future": "{0} жылдан кийин",
          "auto": {
            "0": "быйыл",
            "1": "эмдиги жылы",
            "-1": "былтыр"
          }
        }
      }
    },
    "tk": {
      "tag": "tk-TM",
      "months": {
        "format": {
          "long": [
            "ýanwar",
            "fewral",
            "mart",
            "aprel",
            "maý",
            "iýun",
            "iýul",
            "awgust",
            "sentýabr",
            "oktýabr",
            "noýabr",
            "dekabr"
          ],
          "short": [
            "ýan",
            "few",
            "mart",
            "apr",
            "maý",
            "iýun",
            "iýul",
            "awg",
            "sen",
            "okt",
            "noý",
            "dek"
          ]
        },
        "standalone": {
          "long": [
            "Ýanwar",
            "Fewral",
            "Mart",
            "Aprel",
            "Maý",
            "Iýun",
            "Iýul",
            "Awgust",
            "Sentýabr",
            "Oktýabr",
            "Noýabr",
            "Dekabr"
          ],
          "short": [
            "Ýan",
            "Few",
            "Mar",
            "Apr",
            "Maý",
            "Iýun",
            "Iýul",
            "Awg",
            "Sen",
            "Okt",
            "Noý",
            "Dek"
          ]
        }
      },
      "weekdays": {
        "format": {
          "long": [
            "ýekşenbe",
            "duşenbe",
            "sişenbe",
            "çarşenbe",
            "penşenbe",
            "anna",
            "şenbe"
          ],
          "short": [
            "ýek",
            "duş",
            "siş",
            "çar",
            "pen",
            "ann",
            "şen"
          ]
        },
        "standalone": {
          "long": [
            "Ýekşenbe",
            "Duşenbe",
            "Sişenbe",
            "Çarşenbe",
            "Penşenbe",
            "Anna",
            "Şenbe"
          ],
          "short": [
            "Ýek",
            "Duş",
            "Siş",
            "Çar",
            "Pen",
            "Ann",
            "Şen"
          ]
        }
      },
      "patterns": {
        "||short|": "{Month}",
        "||short|d": "{day} {month}",
        "||long|": "{Month}",
        "||long|d": "{day} {month}",
        "|y|short|": "{month} {year}",
        "|y|short|d": "{day} {month} {year}",
        "|y|long|": "{month} {year}",
        "|y|long|d": "{day} {month} {year}",
        "short|||": "{Weekday}",
        "short|||d": "{day} {weekday}",
        "short||numeric|": "{monthNum} {Weekday}",
        "short||numeric|d": "{day}.{monthNum} {weekday}",
        "short||short|": "{Month} {Weekday}",
        "short||short|d": "{day} {month} {weekday}",
        "short||long|": "{Weekday} (aý: {Month})",
        "short||long|d": "{day} {month} {weekday}",
        "short|y||": "{year} {Weekday}",
        "short|y||d": "{year} {day} {weekday}",
        "short|y|numeric|": "{monthNum}.{year} {Weekday}",
        "short|y|numeric|d": "{day}.{monthNum}.{year} {weekday}",
        "short|y|short|": "{month} {year} {Weekday}",
        "short|y|short|d": "{day} {month} {year} {weekday}",
        "short|y|long|": "{month} {year} {Weekday}",
        "short|y|long|d": "{day} {month} {year} {weekday}",
        "long|||": "{Weekday}",
        "long|||d": "{day} {weekday}",
        "long||numeric|": "{monthNum} {Weekday}",
        "long||numeric|d": "{day}.{monthNum} {weekday}",
        "long||short|": "{Month} {Weekday}",
        "long||short|d": "{day} {month} {weekday}",
        "long||long|": "{Month} {Weekday}",
        "long||long|d": "{day} {month} {weekday}",
        "long|y||": "{year} {Weekday}",
        "long|y||d": "{year} {day} {weekday}",
        "long|y|numeric|": "{monthNum}.{year} {Weekday}",
        "long|y|numeric|d": "{day}.{monthNum}.{year} {weekday}",
        "long|y|short|": "{month} {year} {Weekday}",
        "long|y|short|d": "{day} {month} {year} {weekday}",
        "long|y|long|": "{month} {year} {Weekday}",
        "long|y|long|d": "{day} {month} {year} {weekday}"
      },
      "dateTimeGlue": ", ",
      "relative": {
        "second": {
          "past": "{0} sekunt öň",
          "future": "{0} sekuntdan",
          "auto": {
            "0": "häzir"
          }
        },
        "minute": {
          "past": "{0} minut öň",
          "future": "{0} minutdan",
          "auto": {
            "0": "şu minut"
          }
        },
        "hour": {
          "past": "{0} sagat öň",
          "future": "{0} sagatdan",
          "auto": {
            "0": "şu sagat"
          }
        },
        "day": {
          "past": "{0} gün öň",
          "future": "{0} günden",
          "auto": {
            "0": "şu gün",
            "1": "ertir",
            "-1": "düýn"
          }
        },
        "week": {
          "past": "{0} hepde öň",
          "future": "{0} hepdeden",
          "auto": {
            "0": "şu hepde",
            "1": "indiki hepde",
            "-1": "geçen hepde"
          }
        },
        "month": {
          "past": "{0} aý öň",
          "future": "{0} aýdan",
          "auto": {
            "0": "şu aý",
            "1": "indiki aý",
            "-1": "geçen aý"
          }
        },
        "year": {
          "past": "{0} ýyl öň",
          "future": "{0} ýyldan",
          "auto": {
            "0": "şu ýyl",
            "1": "indiki ýyl",
            "-1": "geçen ýyl"
          }
        }
      }
    }
  }
}
